import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Inventory from '@/components/Inventory'
import ItemGallery from '@/components/ItemGallery'
import Contact from '@/components/Contact'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [{
      path: '/',
      component: Home,
  }, {
      path: '/inventory',
      component: Inventory,
  }, {
      path: '/inventory/:item',
      component: ItemGallery,
  }, {
      path: '/contact',
      component: Contact
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js